import { RootState } from '../models';

export const selectIsPlaying = (state: RootState) => {
	const isPlaying = state.data.isLoaded ? state.video.isPlaying : false;
	return isPlaying;
};
